
export const GET_LIST_USER = 'GET_LIST_USER';
export const GET_LIST_USER_SUCCESS = 'GET_LIST_USER_SUCCESS';
export const GET_LIST_USER_FAIL = 'GET_LIST_USER_FAIL';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';

export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';

export const GET_USER = 'GET_USER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAIL = 'GET_USER_FAIL';

export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAIL = 'GET_PROFILE_FAIL';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';
export const UPDATE_MY_PROFILE = 'UPDATE_MY_PROFILE';
